/**
 * Test/A11y configuration
 * Used when REACT_APP_A11Y_TEST=true for running Playwright accessibility tests
 * This configuration bypasses authentication and uses a mock API server
 */
import { LogLevel } from '@azure/msal-browser';
import type { RedirectRequest } from '@azure/msal-browser';

// Mock MSAL configuration - not used in test mode, but needed for type safety
export const msalConfig = {
  auth: {
    clientId: 'test-client-id',
    authority: 'https://login.microsoftonline.com/test-tenant',
    redirectUri: 'http://localhost:3000',
    postLogoutRedirectUri: 'http://localhost:3000',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        // Suppress MSAL logs in test mode
      },
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

// Mock corporate MSAL config
export const msalConfigCorporate = {
  ...msalConfig,
};

// Mock login request
const b2cScopes: string[] = [];
const corporateScopes: string[] = [];

export const getLoginRequest = (authProvider: 'b2c' | 'corporate'): RedirectRequest => {
  const scopes = authProvider === 'corporate' ? corporateScopes : b2cScopes;
  return { scopes };
};

export const loginRequest: RedirectRequest = {
  scopes: b2cScopes,
};

export const loginRequestCorporate: RedirectRequest = {
  scopes: corporateScopes,
};

// Test-specific API settings - points to mock server (json-server on port 8085)
export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8085',
  timeout: 30000,
};

export const appConfig = {
  enableDebugMode: true,
  enableAnalytics: false,
  logLevel: LogLevel.Error,
  applicationInsightsConnectionString: '', // No telemetry in test mode
};

// Flag to indicate test mode
export const isTestMode = true;
